// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"bbb4e125","977":"00553383"}[chunkId] + ".chunk.js";
};